import { Component, OnDestroy, OnInit,OnChanges, TemplateRef, ViewChild,Input,Output,EventEmitter, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { HaloModalSize, HaloModalService } from 'src/app/core/halo-modal/halo-modal';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { MultiFacilityModel } from '../services/multi-facility.model';
import { MultiFacilityService } from '../services/multi-facility.service';

@Component({
  selector: 'app-multifacility-selector-tree',
  templateUrl: './multifacility-selector-tree.component.html',
  styleUrls: ['./multifacility-selector-tree.component.scss'],
})
export class MultifacilitySelectorTreeComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  facilities: MultiFacilityModel[];
  facilityAllCount:number;
  selectedCount:number;
  searchInput: string = '';
  checkedAll: boolean = false;
  showUnSavedChangesModal = false;
  unsavedChangesPopupData = {
    title: 'UNSAVED.CHANGES',
    message: 'UNSAVED.CHANGES.MESSAGE',
    isWarningPopup: true,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'NO',
    isSecondaryTextButton: false,
  };   
  @Input() isFacilitySearchInputAvailable = true;
  @Input() showInfoLabel = false;
  @Input() currentUrl: string;
  @Input() multiFacilities: any;
  @Input() isPopup = false;
  @Output() selectedFacilityChanged = new EventEmitter<any>();
  @Output() lastSelectedFacilityChanged = new EventEmitter<any>();
  @Output() redirectRouteChanged = new EventEmitter<any>();
  private sub = new Subscription();
  constructor(
    private rootScopeService: RootScopeService,
    private _multiFacilityService: MultiFacilityService,
    private _facilityService: FacilityService,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    this.getRootScopeData();
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes && changes.multiFacilities && changes.multiFacilities.currentValue && changes.multiFacilities.currentValue !== changes.multiFacilities.previousValue){
      this.selectDefault(changes.multiFacilities.currentValue);
      this.facilities = changes.multiFacilities.currentValue;
      this.facilityAllCount = this.getCount(changes.multiFacilities.currentValue);
      this.selectedCount = this.getSelectedCount(changes.multiFacilities.currentValue);
      this.checkedAll = this.facilityAllCount === this.selectedCount;
      const facIds = this.getSelectedFacility(this.facilities);
      this.selectedFacilityChanged.emit(facIds);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  filter(facilities: MultiFacilityModel[]) {
    let filteredFacs: MultiFacilityModel[] = [];
    facilities?.forEach(facility => {
      facility.children = this.filter(facility.children);
      facility.isEnabled = this.isValidLFODSupportFacility(facility) && 
        (facility.isAdmin || this._facilityService.getFacilityById(facility.facilityId)?.summary?.userRights.lfodEnabledEquipment !== 'H');
      if(facility.isEnabled || this.hasLFODEnabledChildren(facility)) {
        filteredFacs.push(facility);
      }
    });
    return filteredFacs;
  }

  hasLFODEnabledChildren(facModel: MultiFacilityModel) {
    if(!facModel || !facModel.children) return false;
    for(let child of facModel.children) {
      if(child?.isEnabled || this.hasLFODEnabledChildren(child)) return true;
    }
    return false;
  }

  selectDefault(facilities: MultiFacilityModel[]) {
    facilities?.forEach(facility => {
      if (this._facilityService.selectedMultiFacilities()?.findIndex(f => f === facility.facilityId) > -1 && 
          this.isValidLFODSupportFacility(facility)) {
        facility.isSelected = true;
      } else {
        facility.isSelected = false;
      }
      facility.isExpanded = this.isPopup === true?false:true;
      this.selectDefault(facility.children);
    });
  }

  isValidLFODSupportFacility(facilityData: MultiFacilityModel) {
    return facilityData ? this._multiFacilityService.isMultifacilitySupported(this.currentUrl??this.router.url, facilityData) : false;
  }

  onSearch(val: string) {
    val = val.toLowerCase();
    this.facilities = this.multiFacilities.filter((i:any) => {
      let foundChild = this.searchChildren(i.children, val);
      let foundSelf = i.facilityName.toLowerCase().includes(val);
      return foundChild || foundSelf;
    });
  }

  searchChildren(facilities: MultiFacilityModel[], val: string) {
    facilities = facilities.filter((i) => {
      let foundChild = this.searchChildren(i.children, val);
      let foundSelf = i.facilityName.toLowerCase().includes(val);
      return foundChild || foundSelf;
    });
    return facilities.length > 0;
  }

  onSelectAll() {
    this.checkedAll = !this.checkedAll;
    this.updateSelectFlag(this.multiFacilities, this.checkedAll);
    this.selectedCount = this.checkedAll ? this.facilityAllCount : 0;
    const facIds = this.getSelectedFacility(this.multiFacilities);
    this.selectedFacilityChanged.emit(facIds);
  }

  onSelect(facility?: MultiFacilityModel) {
    if (facility && facility.isEnabled) {
      facility.isSelected = !facility.isSelected;
      this.updateSelectFlag(facility.children, facility.isSelected);  
      this.selectedCount = this.getSelectedCount(this.multiFacilities);
      this.checkedAll = this.facilityAllCount === this.selectedCount;  
      this.lastSelectedFacilityChanged.emit({facilityId:facility.facilityId,isSelected:facility.isSelected});
    }
    const facIds = this.getSelectedFacility(this.multiFacilities);
    this.selectedFacilityChanged.emit(facIds);
  }

  getCount(facilities: MultiFacilityModel[]) {
    let count = 0;
    facilities?.forEach(facility => {
      if (this.isValidLFODSupportFacility(facility)) {
        count++;
      }
      count += this.getCount(facility.children)
    });
    return count;
  }

  getSelectedCount(facilities: MultiFacilityModel[]) {
    let count = 0;
    facilities?.forEach(facility => {
      if (facility?.isSelected) {
        count++;
      }
      count += this.getSelectedCount(facility.children)
    });
    return count;
  }

  getSelectedFacility(facilities: MultiFacilityModel[]) {
    let facIds: any[] = [];
    facilities?.forEach(facility => {
      if (facility?.isSelected) {
        facIds.push({"facilityId":facility.facilityId,"facilityName":facility.facilityName});       
      }      
      facIds = facIds.concat(this.getSelectedFacility(facility?.children));
    });    
    return facIds;
  }

  updateSelectFlag(facilities: MultiFacilityModel[], selectFlag: boolean) {
    facilities?.forEach(facility => {
      if(facility.isEnabled && !facility.isDisabledSelectedFacility) {
        facility.isSelected = selectFlag;
      }
      this.updateSelectFlag(facility.children, selectFlag);
    });
  }

  highlight(facilityName: string) {
    if (!this.searchInput) {
      return facilityName;
    }

    return facilityName.replace(new RegExp(this.searchInput, 'gi'), match => {
      return '<span style="color:#4196b4">' + match + '</span>';
    });
  }

  getRootScopeData(): void {
    const rootScopeChanges = this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
    this.sub.add(rootScopeChanges);
  }


  onClickRedirection(route:string){
    if(route === "MANAGE.FACILITIES"){
      if (this.rootScopeData.isPageHasUnsavedChanges) {
        this.showUnSavedChangesModal = true;
        return;
      } else {
        this.redirectRouteChanged.emit("/facility/manage");
      }
    }
  }

  moveAwayFromCurrentPage() {
    this.redirectRouteChanged.emit("/facility/manage");
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.closeUnSavedChangesModal();
  }

  closeUnSavedChangesModal() {
    this.showUnSavedChangesModal = false;
  }
}

